import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import {
  tourSetActiveMultiPartAction,
  setSelectPointId,
} from 'actions/FullTour/full_tour_view.action';
import { removePlaceIdInCreateTour } from 'actions/Place/place.action';
import store from 'app/store';
import { Point } from '../../../../libs/map/drive/Point';
import LitePointsListItem from './litePointsListItem';

let isFocusSelectedListPoint = false;

const PointsTourFull = (props) => {
  const dispatch = useDispatch();

  const { edit, closePreview } = props;

  const dataPoint = useSelector((store) => store.tourFullData.dataPoint);

  const publicTypeRequiredFiled = useSelector(
    (store) => store.tourFullData.publicTypeRequiredFiled
  );

  const selectedPoint = useRef(null);
  const selectedPointStyle = useRef(null);

  useEffect(() => {
    if (selectedPoint.current) {
      selectedPoint.current.scrollIntoView({
        behavior: 'instant',
        block: 'nearest',
      });
    }
    selectedPoint.current = null;
  }, [selectedPoint.current]);

  useEffect(() => {
    if (edit && Object.keys(dataPoint).length > 0) {
      isFocusSelectedListPoint = true;
    }
  }, [dataPoint]);

  // POINT FUNCTION
  const deletePoint = (point) => {
    const { id, isEmpty = false, place_id, place_type } = point;
    if (place_id || place_type) {
      dispatch(removePlaceIdInCreateTour(place_id));
    }
    if (isEmpty) {
      publish(way.DRIVE_LIST_REMOVE_EMPTY_VIA_POINT, { customId: id });
    } else {
      publish(way.DRIVE_MAP_POINT_REMOVE, { customId: id });
    }
  };

  const checkWrongPointPosition = (lat, lng) => {
    publish(way.DRIVE_BUILDER_MOVE_MAP, { latLng: { lat, lng }, zoom: 15 });
  };

  const addPoint = (index) => {
    publish(way.DRIVE_LIST_ADD_EMPTY_VIA_POINT, {
      type: Point.Type.VIA,
      index,
    });
    publish(way.DRIVE_MAP_STATIC_POINT_SELECTED, { customId: 0 });
  };

  const convertToVia = (customId, e) => {
    e.stopPropagation();
    e.preventDefault();
    publish(way.DRIVE_MAP_POINT_SET_TYPE, { customId, type: Point.Type.VIA });
    closePreview();
  };

  const convertToDrag = (customId, e) => {
    e.stopPropagation();
    e.preventDefault();
    publish(way.DRIVE_MAP_POINT_SET_TYPE, { customId, type: Point.Type.DRAG });
    closePreview();
  };

  const convertStartToHome = (e, customId) => {
    e.stopPropagation();
    e.preventDefault();
    publish(way.DRIVE_MAP_POINT_SET_TYPE, {
      customId,
      type: Point.Type.START,
      isLastBehind: false,
      switcher: true,
    });
    closePreview();
  };

  const convertEndToHome = (e, customId) => {
    e.stopPropagation();
    e.preventDefault();
    publish(way.DRIVE_MAP_POINT_SET_TYPE, {
      customId,
      type: Point.Type.END,
      isLastBehind: false,
      switcher: true,
    });
    closePreview();
  };

  // DRAG AND DROP FUNCTION
  const moveCard = (dragIndex, hoverIndex) => {
    const pointList = store.getState().tourFullData.activeMultiPart.points;
    const points = pointList.slice();
    const dragCard = pointList[dragIndex];
    points.splice(dragIndex, 1);
    points.splice(hoverIndex, 0, dragCard);
    dispatch(tourSetActiveMultiPartAction(points));
  };

  const dragEnd = (item) => {
    publish(way.DRIVE_LIST_POINT_UPDATE_INDEX, {
      customId: item.id,
      index: item.index,
    });
  };

  // POINT INPUT DROP DOWN MENU, SUFFIX ICON
  const itemClickHandler = (point) => {
    const prevPoint = dataPoint;
    if (point && !point.isEmpty && prevPoint.id !== point.id) {
      publish(way.DRIVE_MAP_STATIC_POINT_SELECTED, { customId: point.id });
    } else if (!edit || point.isEmpty) {
      publish(way.DRIVE_MAP_STATIC_POINT_SELECTED, { customId: 0 });
    }
  };

  const itemOverHandler = (point, unSelect = false) => {
    if (point && !point.isEmpty && !unSelect) {
      publish(way.DRIVE_MAP_STATIC_POINT_MOUSEENTER, { customId: point.id });
      dispatch(setSelectPointId(point.id));
    } else {
      publish(way.DRIVE_MAP_STATIC_POINT_MOUSEENTER, { customId: 0 });
      dispatch(setSelectPointId(0));
    }
  };

  const setSelectedAutocomplete = (ref, point) => {
    const prevPoint = dataPoint;
    if (ref && prevPoint.id === point.id && isFocusSelectedListPoint) {
      ref.focus();
      isFocusSelectedListPoint = false;
    }
  };

  const setSelectedPoint = (ref, point) => {
    if (dataPoint.id === point.id && ref) {
      selectedPoint.current = ref;
      selectedPointStyle.current = ref;
    }
    if (!ref) selectedPoint.current = null;
  };

  const getClassForSelect = () => {
    return 'selecedInput';
  };

  const fncs = {
    ...props,
    addPoint,
    convertToVia,
    convertToDrag,
    itemClickHandler,
    itemOverHandler,
    setSelectedPoint,
    getClassForSelect,
    moveCard,
    dragEnd,
    deletePoint,
    setSelectedAutocomplete,
    convertStartToHome,
    convertEndToHome,
    checkWrongPointPosition,
  };

  return (
    <div
      className="tourFullPoints"
      style={
        !publicTypeRequiredFiled.points
          ? { border: '1px solid red' }
          : { border: '1px solid transparent' }
      }
    >
      <div className="tourFullPointsScroll">
        <LitePointsListItem {...fncs} />
      </div>
    </div>
  );
};

export default PointsTourFull;
